import React, { useRef } from 'react';
import {
  TextField,
  SelectField,
  List as ListAdmin,
  Datagrid,
} from 'react-admin';

import { ProtegerPagina } from '../../layout/VerificaPermissaoPage';
import { PERMISSAO_TELA_UNIDADES_LISTAR } from '../../utils/dadosTelas';
import ListActions from './ActionsList';
import choices from './choices';
import Filter from './Filter';

const List = (props) => {
  const refDialogoDeleteResource = useRef(null);
  const refDialogoAtivaResource = useRef(null);

  function deleteHundle(record) {
    if (refDialogoDeleteResource.current)
      refDialogoDeleteResource.current.handleOpen(record);
  }

  function ativarHandle(record) {
    if (refDialogoAtivaResource.current)
      refDialogoAtivaResource.current.handleOpen(record);
  }
  return (
    <ProtegerPagina permissao={PERMISSAO_TELA_UNIDADES_LISTAR}>
      <ListAdmin
        {...props}
        filters={<Filter />}
        title="Unidades de Produtos"
        filterDefaultValues={{ ativo: true }}
        isDelete
        isButtonAtivo
        exporter={false}
        bulkActionButtons={false}
        actions={<ListActions enabledCreate />}
      >
        <Datagrid {...props}>
          <TextField source="nome" label="Descrição" />
          <SelectField
            sortable={false}
            source="tipo"
            label="Gerenciamento"
            choices={choices}
          />
        </Datagrid>
      </ListAdmin>
    </ProtegerPagina>
  );
};

export default List;
